import React, { Component } from 'react';

interface IProps {
    onClick(v: any): void;
    className?: string;
}

export class GetStartedButton extends Component<IProps, any> {
    render() {
        return (
            <div className={`btn-primary next big ${this.props.className ?? ''}`} onClick={this.props.onClick}>Get Started</div>
        );
    }
}
